import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { any, isNil, either, compose, isEmpty, path, complement } from 'ramda';

import { tileRow } from './TileRow.less';

const check = either(isNil, compose(isEmpty, path(['props', 'children'])));

const TileRow = ({ children, title }) =>
  any(complement(check), Children.toArray(children)) ? (
    <Row top="xs" className={tileRow}>
      <Col xs={5}>
        <p>{title}</p>
      </Col>
      <Col xs={7}>{children}</Col>
    </Row>
  ) : null;

TileRow.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default TileRow;
